import { useEffect, useState } from 'react'
import api from '../services/api'

// Carga da natureza jurídica dos clientes PJ já cadastrados, consultando a BrasilAPI um CNPJ por vez
// (roda no servidor em segundo plano; dá pra fechar a janela e voltar pra ver o andamento).

interface Estado {
  rodando: boolean; total: number; feitos: number; atualizados: number; entes: number
  erros: number; naoEncontrados: number; iniciadoEm: string | null; terminadoEm: string | null; ultimoErro: string
}

const fmtHora = (iso: string | null) => (iso ? new Date(iso).toLocaleString('pt-BR') : '—')

export default function CargaNaturezaJuridicaModal({ onClose }: { onClose: () => void }) {
  const [st, setSt] = useState<Estado | null>(null)
  const [erro, setErro] = useState('')

  async function atualizar() {
    try { setSt((await api.get('/erp/clientes-natjur-lote')).data) } catch { /* mantém o último */ }
  }
  useEffect(() => {
    atualizar()
    const t = setInterval(atualizar, 3000)
    return () => clearInterval(t)
  }, [])

  async function acao(caminho: string) {
    setErro('')
    try { setSt((await api.post(caminho)).data) }
    catch (e: any) { setErro(e?.response?.data?.error || 'Erro.') }
  }

  const pct = st && st.total ? Math.round((st.feitos / st.total) * 100) : 0
  const restanteMin = st && st.rodando ? Math.ceil(((st.total - st.feitos) * 1.7) / 60) : 0

  return (
    <div onClick={e => e.target === e.currentTarget && onClose()}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.45)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 10, width: 520, maxWidth: '94vw', boxShadow: '0 20px 50px rgba(0,0,0,.3)', overflow: 'hidden' }}>
        <div style={{ background: '#1b3f7b', color: '#fff', padding: '0.8rem 1.1rem' }}>
          <div style={{ fontWeight: 700, fontSize: '0.95rem' }}>Natureza jurídica dos clientes (Receita)</div>
          <div style={{ fontSize: '0.75rem', color: '#dbeafe', marginTop: 2 }}>Consulta na BrasilAPI os clientes PJ que ainda não têm natureza jurídica</div>
        </div>
        <div style={{ padding: '1rem 1.1rem', fontSize: '0.84rem', color: '#1f2937' }}>
          {!st ? 'Carregando...' : (
            <>
              <div style={{ height: 10, background: '#e5e7eb', borderRadius: 999, overflow: 'hidden', marginBottom: 8 }}>
                <div style={{ width: `${pct}%`, height: '100%', background: st.rodando ? '#1b3f7b' : '#16a34a', transition: 'width .4s' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.3rem 1rem' }}>
                <span>Situação: <b>{st.rodando ? `Rodando (${pct}%)` : st.terminadoEm ? 'Concluída' : 'Parada'}</b></span>
                <span>Consultados: <b>{st.feitos} / {st.total}</b></span>
                <span>Gravados: <b>{st.atualizados}</b></span>
                <span>Entes governamentais: <b style={{ color: '#1b3f7b' }}>{st.entes}</b></span>
                <span>Não encontrados: <b>{st.naoEncontrados}</b></span>
                <span>Erros: <b style={{ color: st.erros ? '#dc2626' : undefined }}>{st.erros}</b></span>
                <span>Início: {fmtHora(st.iniciadoEm)}</span>
                <span>{st.rodando ? `Faltam ~${restanteMin} min` : `Fim: ${fmtHora(st.terminadoEm)}`}</span>
              </div>
              {st.ultimoErro && <div style={{ marginTop: 8, fontSize: '0.74rem', color: '#b91c1c' }}>Último erro: {st.ultimoErro}</div>}
              <p style={{ fontSize: '0.74rem', color: '#6b7280', margin: '0.8rem 0 0' }}>
                Uma consulta a cada ~1,5 s pra não sobrecarregar a API. Só pega quem ainda não tem natureza jurídica:
                dá pra parar e continuar depois sem repetir. Pode fechar esta janela — continua rodando no servidor.
              </p>
            </>
          )}
          {erro && <div style={{ color: '#dc2626', fontSize: '0.78rem', marginTop: 8 }}>{erro}</div>}
          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
            <button className="btn btn-sm" onClick={onClose} style={{ color: '#6b7280' }}>Fechar</button>
            {st?.rodando
              ? <button className="btn btn-sm" onClick={() => acao('/erp/clientes-natjur-lote/parar')} style={{ background: '#fee2e2', color: '#b91c1c', border: '1px solid #fca5a5' }}>Parar</button>
              : <button className="btn btn-sm btn-primary" onClick={() => acao('/erp/clientes-natjur-lote')}>{st?.terminadoEm ? 'Rodar de novo' : 'Iniciar'}</button>}
          </div>
        </div>
      </div>
    </div>
  )
}
